"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayType = void 0;
const isArrayType = function ({ type }) {
    return type === 'array';
};
exports.isArrayType = isArrayType;
